import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';

interface DoctorLeaderboardProps {
  data: { doctorId: string; doctorName: string; answered: number; assigned: number }[];
  isLoading?: boolean;
}

export function DoctorLeaderboard({ data, isLoading }: DoctorLeaderboardProps) {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Doctor Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-10 w-full" />
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Doctor Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="flex h-32 items-center justify-center text-sm text-muted-foreground">
            No doctor activity data
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Doctor Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Mobile: stacked cards */}
        <div className="space-y-3 sm:hidden">
          {data.map((doc) => (
            <div key={doc.doctorId} className="rounded-lg border p-3">
              <p className="font-medium">{doc.doctorName}</p>
              <div className="mt-1 flex gap-4 text-sm text-muted-foreground">
                <span>Answered: {doc.answered}</span>
                <span>Assigned: {doc.assigned}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: table */}
        <div className="hidden sm:block">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Doctor</TableHead>
                <TableHead className="text-right">Answered</TableHead>
                <TableHead className="text-right">Assigned</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((doc) => (
                <TableRow key={doc.doctorId}>
                  <TableCell className="font-medium">{doc.doctorName}</TableCell>
                  <TableCell className="text-right">{doc.answered}</TableCell>
                  <TableCell className="text-right">{doc.assigned}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
